import moment from 'moment';

const formatDate = value => {
  if (!value) {
    return '';
  }
  return moment(value).format( 'MM/DD/YYYY');
}

export const formatFormElementsForSubmission = (formElements) => {
  formElements.map(formElement => {
    switch (formElement.type) {
      case 'datebox':
        return formElement.value = formatDate(formElement.value);
      default:
        return formElement;
    }
  });
}


// WEBPACK FOOTER //
// ./src/lib/FormUtil.js